// Visual archetype each role's front face uses.
//
// Six templates, each with its own composition, frame, and typography. The
// goal is that two roles in different archetypes look like they belong to
// different decks — Sheriff (DOSSIER, manila folder) and Don (WANTED, torn
// poster) shouldn't share a single pixel of layout. Within an archetype the
// accent color and the central illustration still differentiate roles.
//
// This map is purely cosmetic and lives client-side. The server never reads
// it, so adding a new role only requires adding one line here.

export type CardArchetype =
  | 'dossier'   // case-file folder: investigators, snitches, archivists
  | 'wanted'    // torn bounty poster: killers, mafia muscle
  | 'tarot'     // arcana card with mirrored bottom: occult, ritual
  | 'parlor'    // playing card with corner pips: tricksters, charmers
  | 'vellum'    // refined cream letterpress: civic, everyday town
  | 'infernal'; // scorched paper with ember glow: chaos, fire, beasts

export const ROLE_ARCHETYPE: Record<string, CardArchetype> = {
  // ── TOWN ──
  civilian:   'vellum',
  sheriff:    'dossier',
  doctor:     'vellum',
  lawyer:     'parlor',
  bodyguard:  'vellum',
  mayor:      'parlor',
  vigilante:  'wanted',
  bus_driver: 'vellum',
  veteran:    'vellum',
  spy:        'dossier',
  watcher:    'dossier',
  priest:     'tarot',
  detective:  'dossier',
  escort:     'parlor',
  monk:       'tarot',
  coroner:    'vellum',
  jailer:     'vellum',
  tracker:    'dossier',

  // ── MAFIA ──
  don:         'wanted',
  goon:        'wanted',
  consigliere: 'dossier',
  framer:      'dossier',
  janitor:     'vellum',
  hitman:      'wanted',
  saboteur:    'infernal',
  wheelman:    'wanted',
  mole:        'dossier',
  capo:        'wanted',
  strangler:   'wanted',
  disguiser:   'parlor',

  // ── SOLO ──
  arsonist:     'infernal',
  maniac:       'infernal',
  werewolf:     'infernal',
  survivor:     'vellum',
  jester:       'parlor',
  witch:        'tarot',
  executioner:  'tarot',
  cultist:      'tarot',
  plaguebearer: 'tarot',
};

export function archetypeOf(roleId: string): CardArchetype {
  return ROLE_ARCHETYPE[roleId] ?? 'vellum';
}
